import styled from "@emotion/styled";
export const StyledProductFeaturesTableSection = styled.div`
  text-align: left;
  display: flex;
  justify-content: flex-start;
  padding: 12px 0px;
  border-bottom: 1px ${({ isNewPricing })=>isNewPricing ? 'solid #C3C6D4' : 'solid rgb(230, 233, 239)'};
  grid-column: 1/-1;
  
  &.feature-section-name ~ .feature-section-name {
    margin-top: ${({ isNewPricing })=>isNewPricing ? '70px' : 'inherit'};
  }
  
  h3 {
    margin: 0;
    font-weight: ${({ isNewPricing })=>isNewPricing ? 600 : 700};
    letter-spacing: ${({ isNewPricing })=>isNewPricing ? -0.1 : 0.361538}px;
    font-size: ${({ isNewPricing })=>isNewPricing ? 20 : 16}px;
    padding: ${({ isNewPricing })=>isNewPricing ? '24px 0' : 'inherit'};
  }
`;
